'use client';

import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How does MenuMate help me manage my catering orders?",
    answer: "MenuMate provides a comprehensive order management system that tracks orders from initial inquiry to completion. You can manage order status, track customer details, handle payments, and monitor inventory all in one place. Our real-time updates ensure you never miss an important order detail."
  },
  {
    question: "Can I accept payments directly through MenuMate?",
    answer: "Payment processing is coming soon! We're working on integrating secure payment solutions to help you accept online payments, track payment status, and generate professional invoices. Currently, you can manage payment tracking and invoice generation for offline payments."
  },
  {
    question: "How does the inventory management system work?",
    answer: "Our inventory system lets you track all your catering supplies, set low stock alerts, and manage suppliers. You can monitor ingredient usage per order, track inventory allocation for events, and maintain detailed audit logs. This helps prevent stockouts and reduces food waste."
  },
  {
    question: "Is there a mobile-friendly way for my customers to place orders?",
    answer: "Absolutely! MenuMate provides mobile-responsive digital menus and ordering pages. Your customers can browse your menu, customize orders, and complete checkout seamlessly on any device. You can also embed our ordering system into your existing website."
  },
  {
    question: "What kind of reporting and analytics does MenuMate provide?",
    answer: "MenuMate offers comprehensive analytics including revenue trends, customer insights, order patterns, and payment tracking. You can view detailed reports on your business performance, identify popular menu items, and track customer behavior to make data-driven decisions for growth."
  }
];

export const FAQSection = () => {
  return (
    <div className="w-full py-16 px-2 sm:px-4 sm:py-20 md:py-24 lg:py-32 bg-gray-50">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl font-normal mb-4 sm:text-3xl sm:mb-5 md:text-4xl md:mb-6 lg:text-5xl">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground max-w-xs mx-auto text-base leading-relaxed sm:max-w-lg sm:text-lg md:max-w-2xl">
            Get answers to common questions about MenuMate's catering management features.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`} 
              className="bg-white rounded-lg border border-gray-200 px-6 py-2"
            >
              <AccordionTrigger className="text-left font-medium hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};